import { render, staticRenderFns } from "./tumour.vue?vue&type=template&id=5069700e&scoped=true"
import script from "./tumour.vue?vue&type=script&lang=js"
export * from "./tumour.vue?vue&type=script&lang=js"
import style0 from "./tumour.vue?vue&type=style&index=0&id=5069700e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5069700e",
  null
  
)

export default component.exports